export default "__VITE_ASSET__526b434f__"